export default "__VITE_ASSET__622efdc6__"